import { Toast } from "../../dialog/toast";
import { AuxiliumComponent } from "../auxilium-component";

export default class InfoValue extends AuxiliumComponent {
	static observable = ["variation", "prevent-scroll", "value", "label", "max-height", "default"];
	static observableBooleans = ["multiline", "editable", "copyable"];

	constructor() {
		super();

		this.default ??= "&nbsp;";

		if (this.querySelector("chip-dropdown")) {
			this.preventScroll = true;
		}
	}

	parsedCallback() {
		this.classList.add("information-column");

		const valueElement = document.createElementWithContents("div", this.innerHTML.trim() !== "" ? this.childNodes : this.default,
			{
				className: `information__value${this.multiline ? " smart-wrap" : ""} ${this.innerHTML.trim() === "" ? "information__value--empty" : ""}`.trim()
			});

		if (this.maxHeight) {
			valueElement.tabIndex = 0;
		}

		this.appendChild(valueElement);

		if (this.label || this.editable || this.copyable) {
			const labelDiv = document.createElementWithContents("div", this.label, { className: "information__description" });

			if (this.editable) {
				const editButton = document.createElementWithContents("chip-button", null, {
					buttonStyle: "icon",
					icon: "fas fa-pencil",
					className: "information__edit",
					variation: "body",
					size: "sm",
					tooltip: "Edit",
					onclick: () => this.raiseEvent("editclicked")
				});

				labelDiv.appendChild(editButton);
			}

			if (this.copyable) {
				const copyButton = document.createElementWithContents("chip-button", null, {
					buttonStyle: "icon",
					icon: "fas fa-copy",
					className: "information__copy",
					variation: "body",
					size: "xs",
					tooltip: "Copy",
					onclick: () => {
						if (this.oncopyclicked) {
							this.oncopyclicked();
						} else {
							writeClipboardText(valueElement.classList.contains("information__value--empty") ? "" : valueElement.textContent.trim()).then(() => Toast.ShowSuccess(Localizer.SUCCESS_TITLE, Localizer.COPIED_VALUE));
						}
					}
				});

				labelDiv.appendChild(copyButton);
			}

			this.prepend(labelDiv);
		}
	}

	SetText(text) {
		const container = this.querySelector(".information__value");

		if (container) {
			container.textContent = text;

			if (container.innerHTML.trim() === "") {
				container.classList.add("information__value--empty");
				container.innerHTML = this.default;
			} else {
				container.classList.remove("information__value--empty");
			}
		}
	}

	attributeChanged(name, _, newValue) {
		if (name === "value") {
			const element = this.querySelector(".information__value");
			element.innerHTML = newValue?.trim() ?? this.default;

			element.toggleClass("information__value--empty", !newValue?.trim());
		}
	}
}
